// rev 4 board helpers: card lookup, press routing, state marks
export const LOCK_SVG = (
  <svg className="lockic" viewBox="0 0 12 12" aria-hidden="true"><rect x="2" y="5.2" width="8" height="6" rx="1.2" fill="currentColor" /><path d="M3.9 5.4V3.9a2.1 2.1 0 0 1 4.2 0v1.5" fill="none" stroke="currentColor" strokeWidth="1.3" /></svg>
);

// data state -> [css class, icon]
export const STATE = {
  late: ["late", "!"], waiting: ["yes", "?"], locked: ["lock", "lock"], stale: ["stale", "~"],
  mistake: ["mistake", "×"], not_relevant: ["notrel", "–"], closed: ["closed", "✓"], pressed: ["pressed", "lock"], fine: ["fine", ""],
};
export const STATUS_OPTIONS = [
  ["late", "Late"], ["waiting", "Waiting"], ["locked", "Locked"], ["stale", "Stale"],
  ["mistake", "VIKAS mistake"], ["not_relevant", "Not relevant"], ["pressed", "Pressed"], ["fine", "Fine"],
];

// card kind -> the press-queue panel today's presses use
const KIND_PANEL = {
  task: "6_needs_you", team_task: "9_team_tasks", team_ask: "9_team_tasks", mail: "2_sent", routine: "15_routines",
  gate: "16_gate", plant: "18_plants", site: "19_project_sites", stuck_area: "4_limbo", person: "9_team_tasks",
  mail_group: "2_sent", cost: "8_cost", usage: "8_cost", ai_lane: "10_ai_lanes", document: "14_library",
  doubt: "12_doubts", key_count: "20_keys",
};
export const panelOf = (c) => c.panel || (c.team_only ? "9_team_tasks" : KIND_PANEL[c.kind]) || "board";

// mirror of the server's allow-list (no new presses in this paste)
const UNIVERSAL = ["close", "escalate", "later", "note", "answer", "stale", "not relevant", "vikas mistake"];
const ALLOWED = {
  "6_needs_you": ["move up", "move down", "yes", "drop", "later"], "3_architecture": ["accept", "reject"],
  "9_team_tasks": ["mail", "done", "new date", "accept", "decline", "give"], "2_sent": ["send", "hold", "drop", "edit"],
  "5_build_plan": ["stop", "do first"], "12_doubts": ["answer", "not relevant"], "14_library": ["needs update", "open", "download", "copy"],
  "15_routines": ["run", "pause", "report"], "16_gate": ["approve", "hold", "reject"], "17_done_today": ["reopen"],
  "18_plants": ["raise issue", "ask data"], "19_project_sites": ["ask update", "new date"],
  "21_eshan_reviews": ["approve", "correct", "send back", "not mine"],
};
export const allowed = (panel, action) => UNIVERSAL.includes(action) || (ALLOWED[panel] || []).includes(action);

const ALIASES = {
  "yes, do it": "yes", "yes do it": "yes", "no, drop it": "drop", "no drop it": "drop", "close it": "close",
  "run it now": "run", "pause it": "pause", "report a problem": "report", "give to": "give",
};
export function actionOf(label) {
  const s = String(label || "").trim().toLowerCase().replace(/[.…]+$/, "");
  if (ALIASES[s]) return ALIASES[s];
  if (s.startsWith("yes")) return "yes";
  if (s.startsWith("no")) return "drop";
  return s;
}

export function cardMap(board) {
  const cs = board?.cards;
  if (Array.isArray(cs)) return Object.fromEntries(cs.filter(Boolean).map((c) => [c.id, c]));
  return cs || {};
}

export const linkOf = (c) => c.card_link || `/card/${c.id}`;
export const topicLine = (c) => [c.topic, c.subgroup].filter(Boolean).join(" › ");
export const firstDate = (c) => [c.updated, c.raised, c.date, c.closed_on, c.due_date].find((d) => /^\d{4}-\d{2}-\d{2}/.test(d || ""));

export function sectionTitle(s) { return s.title || s.key; }
